/**
 * Overlaying a tenant's provider settings onto a programme.
 *
 * @module utils/provider-settings
 */

import type { ProviderSettings } from "@/types/provider";

/**
 * The programme with its tenant's provider settings merged over its own copy.
 *
 * Provider details are held per tenant; the programme's copy starts blank and
 * is never edited, so anything printing them reads the tenant's.
 *
 * @returns The same programme when there are no settings to overlay.
 */
export function withTenantProviderSettings<T extends { providerSettings?: ProviderSettings }>(
  programme: T,
  settings: ProviderSettings | null | undefined,
): T {
  if (!settings) {
    return programme;
  }
  return {
    ...programme,
    providerSettings: {
      ...programme.providerSettings,
      ...settings,
      name: settings.name ?? programme.providerSettings?.name ?? "",
    },
  };
}
